import axios from "axios";
import { useState, useEffect } from "react";
import OfferBannerSlider from "../components/Banner";
import ProductSection from "../components/common/ProductSection";
import Contact from "../components/Contact";
import TestimonialCarousel from "../components/HowWeMake";
import Constant from "../helper/Constant";
import miniatureImg from "../assets/images/miniature.png";

const dummyCustomProduct = {
  _id: "custom-miniature-dummy",
  link: "/custom",
  image: miniatureImg,
  name: "Custom Miniature",
  price: 4400,
  offer_price: 4400,
};

const Home = () => {
  const [groupedProducts, setGroupedProducts] = useState({});

  const getAllProducts = async () => {
    try {
      const resp = await axios.get(Constant.getUrls.getAllproducts, {
        params: { limit: 1000 },
      });

      const docs = resp?.data?.data?.docs || [];

      const grouped = docs.reduce((acc, product) => {
        const categoryName =
          product.category?.title ||
          product.category?.name ||
          product.category ||
          "Others";

        const categoryId = product.category?._id || "";

        if (!acc[categoryName]) {
          acc[categoryName] = {
            catId: categoryId,
            products: [],
          };
        }

        acc[categoryName].products.push(product);

        return acc;
      }, {});

      const sortedGrouped = Object.fromEntries(
        Object.entries(grouped).sort(
          ([, firstCategory], [, secondCategory]) =>
            secondCategory.products.length - firstCategory.products.length
        ).map(([category, data]) => [
          category,
          {
            ...data,
            products: data.products.slice(0, 5),
          },
        ])
      );

      sortedGrouped["Custom Miniature"] = {
        catId: "",
        products: [dummyCustomProduct],
      };

      setGroupedProducts(sortedGrouped);
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  useEffect(() => {
    getAllProducts();
  }, []);

  return (
    <>
      <OfferBannerSlider />

      {Object.entries(groupedProducts).map(([category, data]) => (
        <ProductSection
          key={category}
          title={category}
          viewAllLink={
            data.catId ? `/products?catId=${data.catId}` : "/custom"
          }
          products={data.products}
        />
      ))}

      <TestimonialCarousel />
      <Contact />
    </>
  );
};

export default Home;
